<template>
  <PageLayout>
    <template #main>
      <h2 class="text-h3 font-weight-bold navy--text text--darken-1 pb-12">
        Probíhá ověřování emailu...
      </h2>
      <div class="py-12" style="margin-left: 10em">
        <v-progress-circular
          :size="100"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import { call } from "vuex-pathify"

import PageLayout from "@/components/page/auth/PageLayout.vue"
import ToastificationVue from "@/components/ui/Toastification.vue"

export default {
  name: "Registration",
  components: {
    PageLayout,
  },
  mixins: [],
  data() {
    return {}
  },
  computed: {},
  methods: {
    ...call("auth", ["verifyEmail"]),
    invalidRequest(message) {
      const timeout = 5000

      this.$toast.error(
        {
          component: ToastificationVue,
          props: {
            title: "Chyba požadavku",
            text: message,
          },
        },
        { timeout: timeout }
      )

      setTimeout(() => {
        this.$router.push("/login")
      }, timeout)
    },
    sucesfullyVerified() {
      const timeout = 2500

      this.$toast.success(
        {
          component: ToastificationVue,
          props: {
            title: "Email ověřen",
            text: "Můžete se přihlásit do aplikace.",
          },
        },
        { timeout: timeout }
      )

      setTimeout(() => {
        this.$router.push("/login")
      }, timeout)
    },
  },
  mounted() {
    const token = this.$route.query.token

    if (token) {
      this.verifyEmail(token)
        .then(() => {
          this.sucesfullyVerified()
        })
        .catch(() => {
          this.invalidRequest("Neplatný token.")
        })
    } else {
      this.invalidRequest("Neplatná URL.")
    }
  },
}
</script>

<style scoped></style>
